import { Directive, HostListener, Input, OnDestroy } from '@angular/core';
import { finalize, takeUntil } from 'rxjs/operators';
import { MediaApiService } from '@shared-features/services/media-api.service';
import { LoadingService } from '@shared/services/loading.service';
import { SectionStateStatus } from '@shared/enums/section-state-status.enum';
import { Subject } from 'rxjs';

@Directive({
  selector: '[appMediaLink]',
})
export class MediaLinkDirective implements OnDestroy {
  @Input('appMediaLink') mediaId: number;

  private destroy$ = new Subject<void>();

  constructor(private mediaApiService: MediaApiService, private loadingService: LoadingService) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    if (!this.mediaId) return;
    event.preventDefault();
    this.loadingService.startLoading(SectionStateStatus.LoadingTransparent);
    this.mediaApiService
      .getMedia(this.mediaId)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => this.loadingService.stopLoading())
      )
      .subscribe((media) => {
        window.open(media.url, '_blank');
      });
  }
}
